import React from 'react';
import "../styles/MarqueeBanner.css"
const MarqueeBanner = () => {
    return (
        <div className="marquee-container">
            <div className="marquee-text">
                {/* ENJOY FREE SHIPPING ON ORDER ABOVE -  ₹ 1499 */}
                ENJOY FREE SHIPPING ON ORDERS ABOVE ₹1499.
                Shop now and experience hassle-free delivery to your doorstep!
            </div>
        </div>
    );
};

export default MarqueeBanner;
